// File Metadata:
// Filename: imagekit.js
// Version: 1.00
// Created: 2022-11-27 22:13:24
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import ImageKit from 'imagekit-javascript'
import { CONSTANT } from '../config/constants'
const { ik_pub_key } = CONSTANT

const imagekit = new ImageKit({
    publicKey: ik_pub_key,
    urlEndpoint: 'https://ik.imagekit.io/iu4zpl5sr',
    authenticationEndpoint: 'https://declodash.dieuwerdescheemaecker.ovh/api/auth/imagekit'
})

const uploadToImageKit = async (data, onProgress) => {
    let returnObject = {};
    const stringLength = data.length - 'data:image/jpeg;base64,'.length
    const fileSize = 4 * Math.ceil((stringLength / 3) * 0.5624896334383812)
    const customXHR = new XMLHttpRequest();
    
    // Ensure progress event handling
    customXHR.upload.addEventListener('progress', function (e) {
        if (e.loaded <= fileSize) {
            const percent = Math.round((e.loaded / fileSize) * 100);
            console.log(`Uploaded ${percent}%`);
            if (typeof onProgress === 'function') {
                onProgress(percent);
            }
        }
        if (e.loaded === e.total) {
            console.log("Upload done");
            onProgress(100); // Ensure 100% is sent when complete
        }
    });

    const response = await imagekit.upload({
        xhr: customXHR,
        file: data.img,
        fileName: data.name,
        useUniqueFileName: false,
        tags: data.tags
    })

    console.log(response.$ResponseMetadata.statusCode)

    if (response.$ResponseMetadata.statusCode === 200) {
        returnObject = {
            fileId: response.fileId,
            fileName: response.name,
            url: response.url
        }

        return returnObject
    } else {
        throw new Error(response.$ResponseMetadata.statusCode)
    }
}

export default uploadToImageKit
